module.exports = __webpack_public_path__ + "img/TIS.ac66f719.jpg";